<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-05 11:32:32
 * @LastEditTime: 2020-03-18 11:46:20
 * @LastEditors: 陆伟
 -->
<template>
  <div id="scheme-receive-a">
    <!-- 云币领取页面 -->
    <div class="cloud-result" v-if="cloudData.type == 0">
        <div class="cloud-head-portrait"><img :src="cloudData.headUrl" alt=""></div>
        <div class="cloud-head-name">来自{{cloudData.shopName}}的红包</div>
        <div class="cloud-red-bg"><span class="cloud-receive" @click="clickCloud()"></span></div>
    </div>
    <!-- 云币领取结果页面 -->
    <div class="receive-result" v-if="cloudData.type == 1 || cloudData.type == 2 || cloudData.type == 3">
      <div class="receive-top">
        <!-- 根据状态显示相应的文案 -->
        <div class="cloud-receive-tip">
            <span v-if="cloudData.type == 1">恭喜您获得</span>
            <span v-if="cloudData.type == 2">手慢了，红包已被抢光</span>
            <span v-if="cloudData.type == 3">手慢了，红包已失效</span>
        </div>
        <!-- 领取的云币面额 -->
        <div class="cloud-info">
          <div class="cloud-cont" v-if="cloudData.type == 1">
            <div class="cloud-cont-l">{{couponValue1}}<span class="yunbi"><i v-if="couponValue2">.{{couponValue2}}</i>云币</span></div>
            <div class="cloud-cont-r">
              <p class="cloud-title">1云币=1RMB，购物可直接抵扣</p>
              <div class="cloud-full">有效期至：{{cloudData.endTime|formatNew}}</div>
            </div>
          </div>
          <div class="rob-cloud" v-if="cloudData.type == 2">抢光了</div>
          <div class="rob-cloud" v-if="cloudData.type == 3">已失效</div>
        </div>
        <div class="cloud-put-in-text" v-if="cloudData.type == 1 && cloudData.phone">云币已放入 <span>{{cloudData.phone}}</span> 账户</div>
        <!-- 领取人数 -->
        <receive-number ref="ReceiveNumber" :receiveInfo="receiveInfo" :isShowList="isShowList" :getCount="getCount"></receive-number>
      </div>
      <!-- 云币下单 立享优惠 -->
      <div class="cloud-next-part" v-if="shopInfo && shopInfo.length > 0">
        <div class="cloud-shop-titles"><span class="shop-l-bg"></span><span class="shop-title-tip">云币下单 立享优惠</span><span class="shop-r-bg"></span></div>
        <ul class="shop-list ui-rows-wrap ui-rows-justify cloud-shop-20">
            <li v-for="(item, index) in shopInfo" :key="index" @click="goDetail(item,index)">
              <commodities-list ref="CommoditiesList" :item="item" :index="index"></commodities-list>
            </li>
        </ul>
        <div class="hot-shop-more">
            <span class="more-btn" v-show="!isLastPage && !isMorePage && shopInfo.length > 0" @click="goMoreShop()">查看更多</span>
            <span v-show="isLastPage && shopInfo.length > 0 ">- 没有了哦 -</span>
        </div>
        <div class="check-more-cloud" @click="goMore()">查看更多好货</div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import { Toast } from 'mint-ui'
import YunJi from '@/assets/js/YunJi'
import wxShare from '../../../common/wxShare'
import * as Http from '@/pages/commodity/api/share'
import * as Mark from '@/pages/commodity/api/itemMark'
import * as Util from '@/assets/js/Util'

import schemeReceiveB from '@/pages/commodity/views/ShareCloud/components/schemeReceiveB'
import ShareError from '@/pages/commodity/components/ShareError'
import CommoditiesList from '@/pages/commodity/components/CommoditiesList'
import ReceiveNumber from '@/pages/commodity/views/ShareCloud/components/ReceiveNumber'

export default {
  name: 'scheme-receive-a',
  data() {
    return {
      seqId: YunJi.getUrlParams('seqId') || '',
      shareConsumerId: YunJi.getUrlParams('shareConsumerId') || '',
      appCont: YunJi.getUrlParams('appCont') || 0,
      shopId: YunJi.getUrlParams('shopId'), // 获取店铺id,
      wechatData: {},
      vComit: true,
      isShowReload: false, // 是否显示网络异常
      getCount: null, // 领取人数
      isShowList: true,
      markedBuyAttachItemList: [], // 打标买赠商品列表
      pageIndex: 0,
      pageSize: 50,
      couponValue1: null,
      couponValue2: null,
      currPage: 0, // 当前页
      pageSizes: 10,
      totalCount: null,
      shopItemIds: null,
      isShowBrush: true, // 防止重复刷接口
      isMorePage: false,
      isLastPage: false,
      cloudData: {}, // 基本信息
      receiveInfo: [], // 领取人数列表
      shopInfo: [], // 商品列表
      pageId: '00065',
      isScheme: 2,
      aBtestId: ''
    }
  },
  components: { 
    ShareError, CommoditiesList, ReceiveNumber, schemeReceiveB
  },
  filters: {
    formatNew(value) {
      return YunJi.formatNew(value, 'yyyy.MM.dd')
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  activated() {
   
  },
  mounted() {
    // if (!YunJi.isWeiXin() && !YunJi.appUA) {
    //   document.head.innerHTML =
    //     '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">';
    //   document.body.innerHTML =
    //     '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>';
    // }
    this.init();
    
  },
  methods: {
    initLoadThinkingReport() {
      window.thinkingReport.track('page_load', {
        page_id: this.pageId,
        point_id: '21546',
        ABtestId: this.aBtestId
      })
    },
    /**
     * 获取基本信息
     */
    init() {
      const params = {
        seqId: this.seqId,
        shopId: this.shopId,
        appCont: this.appCont,
        shareConsumerId: this.shareConsumerId
      }
      Http.getCouponShare(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.cloudData = res.data
          this.$nextTick(() => {
            if (this.cloudData.couponValue) {
              this.couponValue1 = this.cloudData.couponValue.toString().split('.')[0] || ''
              this.couponValue2 = this.cloudData.couponValue.toString().split('.')[1] || ''
            }
            if (this.cloudData.type !== 0) {
              this.getRecord()
              this.getShopId()
            }
            if (parseFloat(this.appCont) === 0) { // 微信H5调用分享数据
              wxShare({
                title: `${this.cloudData.shopName},给您发云币啦！`, // 分享的标题
                content: this.cloudData.content, // 分享的描述
                // 分享的url地址
                link: `${window.location.origin}${window.location.pathname}?seqId=${encodeURIComponent(this.seqId)}&shareConsumerId=${encodeURIComponent(this.shareConsumerId)}&shopId=${encodeURIComponent(this.shopId)}`, 
                imgUrl: this.cloudData.headUrl, // 默认分享图片
                callback: () => {

                }
              })
            }
          })
        } else if (res.errorCode !== 2418) {
          this.isShowReload = true // errorCode != 0 显示重新加载
        }
      }).catch(() => {
        this.isShowReload = true // errorCode != 0 显示重新加载
      })
    },
    /**
     * 点击领取云币
     */
    clickCloud() {
      if (!this.vComit) return
      this.vComit = false // 防止重复提交
      const params = {
        seqId: this.seqId,
        shopId: this.shopId,
        shareConsumerId: this.shareConsumerId,
        appCont: this.appCont
      }
      Http.getClickCouponShare(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          this.cloudData = res.data
          this.$nextTick(() => {
            if (this.cloudData.couponValue) {
              this.couponValue1 = this.cloudData.couponValue.toString().split('.')[0] || ''
              this.couponValue2 = this.cloudData.couponValue.toString().split('.')[1] || ''
            }
            this.getRecord()
            this.getShopId()
          })
        } else if(res.errorCode == 1000) {
          this.vComit = true
          this.$emit('showRegister')
        } else {
          Toast(res.errorMessage)
          this.vComit = true
        }
      }).catch(() => {
        this.vComit = true
        Toast('网络错误')
      })
    },
    /**
     * 获取领取人列表
     */
    getRecord() {
      const params = {
        seqId: this.seqId,
        consumerId: this.cloudData.consumerId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      Http.getDetailVO(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          this.getCount = res.data.getCount
          this.receiveInfo = res.data.getRecords
          this.$nextTick(() => {
            if (this.receiveInfo && this.receiveInfo.length > 0) {
              for (let i = 0; i < this.receiveInfo.length; i += 1) {
                if (this.receiveInfo[i].consumerName && this.receiveInfo[i].consumerName.length > 6) {
                  this.receiveInfo[i].consumerName = `${this.receiveInfo[i].consumerName.substr(0, 6)}...`
                }
              }
            }
          })
        }
      })
    },
    /**
     * 获取商品ID
     */
    getShopId() {
      const params = {
        shopId: this.shopId,
        pageIndex: this.currPage,
        pageSize: this.pageSizes,
        consumerId: this.cloudData.consumerId,
        coinAmount: this.cloudData.couponMoney,
      }
      Http.getPersonalItemByCoin(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.totalCount = res.data.totalCount
          this.shopItemIds = res.data.itemId
          this.aBtestId = res.data.aBtestId
          this.initLoadThinkingReport()
          this.$nextTick(() => {
            if (this.shopItemIds) {
              this.isMorePage = true
              this.getSingleDetail()
            }
          })
        }
      })
    },
    /**
     * 加载更多商品列表信息
     */
    goMoreShop() {
      this.currPage += 1
      this.getShopId()
    },
    /**
     * 获取信息
     */
    getSingleDetail() {
      const prams = {
        itemIdStr: this.shopItemIds
      }
      Http.getBatchItemByIds(prams).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          res.data.forEach((list) => {
            this.shopInfo.push(list)
          })
          const totalPage = Math.ceil(this.totalCount / this.pageSizes) // 总页数
          if ((parseFloat(this.currPage) + 1) >= totalPage) {
            this.currPage = totalPage
          }
          if (totalPage === this.currPage) {
            this.isLastPage = true
          } else {
            this.isLastPage = false
          }
          const itemIds = {
            appCont: this.appCont,
            strVersion: '1',
            itemIds: this.shopItemIds,
            businessMarkType: '1'
          }
          Mark.getItemMark(itemIds).then((res) => {
            if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
              this.markedBuyAttachItemList = res.data
              // 动态在商品列表里面创建 字段 markFlag
              for (let i = 0; i < this.shopInfo.length; i += 1) {
                for (let j = 0; j < this.markedBuyAttachItemList.length; j += 1) {
                  if (this.shopInfo[i].itemId === this.markedBuyAttachItemList[j].itemId) {
                    Vue.set(this.shopInfo[i], 'markFlag', this.markedBuyAttachItemList[j].mark)
                    Vue.set(this.shopInfo[i], 'markDescribe', this.markedBuyAttachItemList[j].markDescribe)
                  }
                }
              }
              this.isMorePage = false
            }
          })
        }
      })
    },
    /**
     * 跳转至对应的商品详情
     * @param item 商品对象
     * @param index 商品位置
     */
    goDetail(item, index) {
      window.thinkingReport.track('click_list', {
        page_id: this.pageId,
        point_id: '21553',
        ABtestId: this.aBtestId,
        item_id: item.itemId,
        tab_name: '为你推荐',
        business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
        index: index + 1
      })
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/detail?itemId=${item.itemId}&appCont=0&shopId=${this.shopId}`
    },
    /**
     * 查看更多好货---跳转去更多特卖逛逛
     */
    goMore() {
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/more?shopId=${this.shopId}&appCont=0&shareShopId=${this.shopId}`
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
  width: 0; /* 滚动条宽度为0 */
  height: 0; /* 滚动条高度为0 */
  display: none; /* 滚动条隐藏 */
}
/*云币领取*/
.cloud-result { position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: auto; box-sizing: border-box; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-bg.png') no-repeat; background-size: 100% 100%; text-align: center;}
/*头像*/
.cloud-head-portrait { margin: .6rem auto 0 auto; width: 1rem; height: 1rem;}
.cloud-head-portrait img { width: 100%; height: 100%; border-radius: 50%; -webkit-border-radius: 50%;}
.cloud-head-name { margin-top: .24rem; opacity: 0.8; font-size: .28rem; color: #4A3303; font-weight: 700; min-height: .32rem;}
.cloud-red-bg { margin-top: .6rem; width: 100%; height: 9.34rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-hot-bg.png') no-repeat; background-size: 100% 100%;}
.cloud-receive { display: inline-block; margin: 1.6rem auto 0 auto; width: 2.16rem; height: 2.16rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-receive.png') no-repeat; background-size: 100% 100%;}
.receive-result { position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: auto; box-sizing: border-box; background-image: linear-gradient(-179deg, #FFCD69 0%, #FCC453 100%);}
.receive-top { width: 100%; min-height: 5.04rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-receive-bg.png') no-repeat; background-size: 100%; padding-bottom: .32rem;}
/*领取文案*/
.cloud-receive-tip { margin-top: .6rem; width: 100%; text-align: center; font-size: .48rem; color: #6C4800; font-weight: 700;}
.cloud-receive-tip span { font-weight: 700;}
.cloud-info { margin: .6rem auto 0 auto; width: 6.54rem; height: 1.88rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-put-bg.png') no-repeat; background-size: 100% 100%;}
.rob-cloud { width: 100%; text-align: center; line-height: 1.88rem; font-size: .6rem;color: #C8C8C8; font-weight: 700;}
.cloud-cont { width: 100%; padding-top: .4rem; height: 1.88rem; }
.cloud-cont-l { width: 2.28rem; height: 1.1rem; float: left; border-right: 1px solid #ddd; color: #F10D3B; font-size: .72rem; text-align: center; line-height: 1.1rem;}
.cloud-cont-l .yunbi { font-size: .24rem; font-weight: 700;}
.cloud-cont-l i { font-style: normal; font-size: .32rem; font-weight: 700;}
.cloud-cont-r { float: left; margin-left: .2rem; color: #F10D3B;}
.cloud-cont-r .cloud-title { margin-top: .15rem; color: #1A1A1A; font-size: .24rem;}
.cloud-cont-r .cloud-full { margin-top: .15rem; font-size: .24rem;}
.cloud-put-in-text {opacity: 0.8; color: #212121; font-size: .24rem; width: 100%; text-align: center; margin-top: .24rem;}
.cloud-put-in-text span {color: #F10D3B; font-weight: 700;}
.receive-number { margin-top: .48rem; width: 100%; text-align: center; color: #fff;}
.receive-number .receive-tip { font-size: .28rem; color: #212121; line-height: .28rem;}
.receive-number .receive-head { margin-top: .2rem; width: 100%; text-align: center;}
.receive-number .receive-head img { display:inline-block; margin-left: -.2rem; width: .48rem; height: .48rem; border:1px solid #fff; border-radius: 50%; -webkit-border-radius: 50%; position:relative;}
.receive-number .receive-head img:first-child { margin-left:0;}
.receive-number .receive-head span {display:inline-block; width: .48rem; height: .48rem; font-size: .28rem; position:absolute;}
.receive-number .receive-open { display: inline-block; margin-top: .4rem; width: .34rem; height: .14rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/receive-open.png') no-repeat; background-size: 100% 100%;}
.receive-number-open { position: relative; margin: .48rem auto 0 auto; width: 6.7rem; text-align: center; height: .28rem; font-size: .28rem;}
.receive-number-open .receive-number-open-tip { position: absolute; top: 0; left: 50%;  width: 2.36rem; margin-left: -1.18rem; background: #FFCD69; color: #1A1A1A; font-size: .24rem;}

.item-bottom-tip{ margin: .48rem auto 0 auto; width: 6.7rem; }
.item-bottom-title { text-align: center;}
.border-1px {position: relative}
.border-1px:before{content: '';display: inline-block; position: absolute;left: 0;top: 0;width: 100%;height: 100%;border-bottom: 1px solid #666;}
@media (-webkit-min-device-pixel-ratio:  1.5),(min-device-pixel-ratio: 1.5){
    .border-1px:before{
        -webkit-transform: scaleY(0.7);transform: scaleY(0.7);
    }
}
@media (-webkit-min-device-pixel-ratio:  2),(min-device-pixel-ratio: 2){
    .border-1px:before{
        -webkit-transform: scaleY(0.5);transform: scaleY(0.5);
    }
}
@media (-webkit-min-device-pixel-ratio:  3),(min-device-pixel-ratio: 3){
    .border-1px:before{
        -webkit-transform: scaleY(0.33);transform: scaleY(0.33);
    }
}

.receive-list {width: 6.7rem;}
.receive-list li { width: 100%; height: .8rem; margin-top: .32rem; position: relative;}
.receive-list li .touxiang { width: .8rem; height: .8rem;}
.receive-list li .touxiang img { width: 100%; height: 100%; border-radius: 50%; -webkit-border-radius: 50%;}
.receive-list li .wxname { width: 3.88rem; height: .8rem; margin-left: .2rem; font-size: .24rem; text-align: left;color: #6C4800;}
.receive-list li .wxname-h { margin-top: .1rem; font-weight: 700;}
.receive-list li .wxname-p { opacity: 0.8;}
.receive-list li .wxprice-r { height: .8rem; width: 1.8rem; text-align: right; color: #F10D3B;}
.receive-list li .wxprice { font-size: .36rem; margin-top: .25rem;}
.receive-list li .wxprice-rmb { font-size: .24rem; font-style: normal;}

.cloud-next-part {background: #FFF4CF; padding: .4rem 0;}
.cloud-shop-titles { margin:0 auto; width: 100%; font-size: .32rem; color: #6C4800; text-align: center;}
.cloud-shop-titles .shop-title-tip { margin: 0 .24rem;}
.cloud-shop-titles .shop-l-bg,.cloud-shop-titles .shop-r-bg { display: inline-block; width: .96rem; height: .14rem;}
.cloud-shop-titles .shop-l-bg { background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-l-bg.png') no-repeat; background-size: 100% 100%;}
.cloud-shop-titles .shop-r-bg { background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/cloud-r-bg.png') no-repeat; background-size: 100% 100%;}
.check-more-cloud { margin: .6rem auto 0 auto; background: #F10D3B; border-radius: 22px; -webkit-border-radius: 22px; font-size: .3rem; color: #fff; width: 6.7rem; height: .88rem; line-height: .88rem; text-align: center;}
.cloud-shop-20 { margin-top: .4rem;}


.hot-shop-more { margin: .2rem auto 0 auto; width: 100%; height: .38rem; font-size: .2rem; text-align: center;}
.hot-shop-more .more-btn { display: inline-block; width: 1.86rem; height: .34rem; line-height: .4rem; border-radius: 2rem; border: 1px solid #000;}
</style>
